const ButtonRightArrow = ({ size = 24, color = "currentColor", className = "", ...props }) => {
  const width = typeof size === "number" ? size : size;
  const height = typeof size === "number" ? (size * 20) / 24 : size;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M22.0791 7.51691L14.6345 0.0722656L13.2095 1.49722L20.6542 8.94187C20.67 8.95772 20.683 8.97501 20.6988 8.99086L0.129883 8.99086L0.129883 11.0065L20.6974 11.0065C20.683 11.0224 20.6686 11.0397 20.6527 11.0555L13.2081 18.5002L14.633 19.9251L22.0763 12.4805C22.739 11.8177 23.105 10.936 23.105 9.99943C23.105 9.0629 22.7405 8.18113 22.0777 7.51691L22.0791 7.51691Z"
        fill={color}
      />
    </svg>
  );
};

export default ButtonRightArrow;
